export const Errors = {
    ASSETS_TO_SUPPLY: 'Not possible to get assets to supply',
    USERS_SUPPLIES: 'Not possible to get your supplies',
    USER_BORROWS: 'Not possible to get your borrows',

    ADD_WALLETS: 'Not possible to add wallets',
    ADD_NETWORK: 'Not possible to add networks',

    TOKENS: 'Not possible to get tokens',
    NO_TOKENS_FOR_AGREEMENT: 'No tokens for agreement ',
    TOKEN_CONTRACT_NOT_AVAILABLE: 'Token Contract not available for token ',

    NO_AVAILABLE_AGREEMENTS: 'No available agreements',
    NO_AGREEMENTS_WITH_ROLE: 'No agreements with role ',
    NO_AGREEMENT_BY_ID: 'No agreement available by ID: ',
    AGREEMENT_CONTRACT_NOT_AVAILABLE: 'Agreement Contract not available for agreement ',
    AGREEMENTS_CONTRACTS_NOT_AVAILABLE: 'Agreements Contracts are not available',

    LEVERAGE_NOT_ALLOWED: 'Leverage not allowed for this address',

    ORGANIZATIONS: 'Not possible to get organizations: ',

    PROVIDERS: 'Not possible to get providers: ',
    MODELS: 'Not possible to get models: ',

    INFO: 'Not possible to get user info: ',
    NO_PRICES_AVAILABLE: 'No prices available',

    VAULTS: 'Not possible to get vaults',
    VAULTS_CONTRACT_NOT_AVAILABLE: 'Vault Contract not available for vault ',
    USERS_VAULTS: 'Not possible to get your vaults',

    MARGIN_ACCOUNTS: 'Not possible to get margin accounts',

    USERS_VAULTS_CONTRACT_NOT_AVAILABLE: 'Vault Contract not available for vault ',
    USERS_VAULTS_PENDING_REWARDS_ERROR: 'Not possible to get pending rewards for vault ',

    INVALID_WALLET_ADDRESS: 'Invalid wallet address',
    INVALID_NETWORK: 'Invalid network',

    USERS_SUPPLIES_CONTRACT_NOT_AVAILABLE: 'Supply Contract not available for agreement ',
    USERS_SUPPLIES_PENDING_REWARDS_ERROR: 'Not possible to get pending rewards for agreement ',
    USERS_SUPPLIES_BALANCE_ERROR: 'Not possible to get balance for agreement ',
    USERS_SUPPLIES_REWARD_ERROR: 'Not possible to get reward for agreement ',

    ORGANIZATION_MEMBERS: 'Not possible to get organization members',

    AGREEMENT_NOT_FOUND: 'Agreement not found',

    ASSET_PRICE_NOT_AVAILABLE: 'Asset price not available',
    WALLET_BALANCE: 'Not possible to get wallet balance',

    FETCH_AGREEMENTS_FROM_CONTRACT: 'Failed to fetch agreement data from contract',
    PERMISSION_DENIED: 'Permission denied',

    NO_CLIENT_POOL_BY_ID: 'No client pool available by ID: ',
};
